import { faIdCard } from '@fortawesome/pro-light-svg-icons'

import { generateUrls } from '@hooks/useBrandGroup'

const generateTabBarItems = (brandGroup) => {
  const urls = generateUrls(brandGroup)
  const { editBrandGroupUrl } = urls

  return [
    {
      icon: faIdCard,
      href: editBrandGroupUrl,
      key: 'details',
      title: brandGroup?.title || 'Brand Group Details',
    },
  ]
}

export default generateTabBarItems
